import { AfterViewInit, OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin, of, Subject } from 'rxjs';
import { BriefComment } from 'src/app/models/brief-comment.model';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { BoardService } from 'src/app/services/sections/job/board.service';
import { ProposalService } from 'src/app/services/sections/job/proposal.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import { ApprovalRequest } from '../models/approval-request.model';

@Component({
	templateUrl: './proposal-note-thread.component.html',
	styleUrls: ['../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss', './proposal-note-thread.component.scss']
})
export class ProposalNoteThreadComponent implements OnInit, OnDestroy, AfterViewInit {

	public readonly ButtonIcons = ButtonIcons;
	public readonly PageType = PageType;
	public moment = moment;

	public isLoading = false;
	public isCommentSubmitting = false;

	public comments: BriefComment[] = [];
	public proposal: ApprovalRequest = null;
	public pageType: PageType;

	public formModel: FormGroup;

	public unsubscriber$ = new Subject<void>();

	public self = this;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private proposalService: ProposalService
	) { }

	ngOnInit(): void {
		this.pageType = this.activatedRoute.snapshot.data.pageType;
		this.comments = (this.activatedRoute.snapshot.data.thread || []) as BriefComment[];
		this.proposal = (this.activatedRoute.snapshot.data.proposal || {}) as ApprovalRequest;

		this.formModel = new FormGroup({
			comment: new FormControl(null, [Validators.required, Validators.pattern(/\S+/)])
		});
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}

	public addComment(): void {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		const form = this.formModel.getRawValue();

		(this.pageType === PageType.BoardMember
			? this.proposalService.addBoardMemberComment(TokenHelper.getToken(this.activatedRoute), form.comment)
			: this.proposalService.addCustomerComment(TokenHelper.getToken(this.activatedRoute), this.proposal.proposalId, form.comment)
		)
			.subscribe(
				() => {
					this.comments.unshift({
						description: this.formModel.getRawValue().comment,
						createdBy: null,
						subject: 'Note Posted',
						createdOn: new Date(),
						isPostedByCurrentUser: true
					});
					this.formModel.reset();
					GlobalSettingsService.isSecondaryLoaderLoading = false;
				}, () => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
				}
			);
	}
}
